/**
 * Asynchronously loads the component
 */
// @ts-expect-error
import Loadable from 'react-loadable';
import SpinnerContainer from '../../components/SpinnerContainer';

export default Loadable({
  loader: () => import(/* webpackChunkName: "RentGuaranteeManagePoliciesPage.loadable" */ './index'),
  loading: SpinnerContainer,
});
